import {
  closeicon,
  coinsIcon,
  donateIcon,
  externalIcon,
  kidIcon,
  logo,
  sponserIcon,
} from "assets/icons";
import { useNavigate } from "react-router-dom";
import { HOME_PATH } from "Routes/paths";

interface AsideProps {
  activeSection: string;
  setActiveSection: React.Dispatch<React.SetStateAction<string>>;
  setShowMobileAside: React.Dispatch<React.SetStateAction<boolean>>;
  showMobileAside: boolean;
}

const Aside = ({
  activeSection,
  setActiveSection,
  setShowMobileAside,
  showMobileAside,
}: AsideProps) => {
  const navigate = useNavigate();
  return (
    <aside
      className={`${
        showMobileAside
          ? "absolute top-0 left-0 z-30 w-[80%] h-screen md:hidden bg-white shadow-xl"
          : "hidden md:block md:min-w-[320px] h-screen bg-white shadow-xl"
      }`}
    >
      {/* logo section  ******/}
      <div className="mt-[10px] w-full min-h-[85px] px-[20px] md:px-0 flex items-center justify-between md:justify-center">
        <img
          onClick={() => navigate(HOME_PATH)}
          className="cursor-pointer"
          src={logo}
          alt=""
        />

        <img
          onClick={() => setShowMobileAside(false)}
          className="md:hidden"
          src={closeicon}
          alt=""
        />
      </div>

      {/* navigation menu  ****************/}
      <div className="pt-[50px] w-full px-[20px] md:px-[30px]">
        <div className="flex flex-col items-start gap-4">
          {/* Orphan Donation History  **********/}
          <div
            onClick={() => {
              setActiveSection("OrphanDonationHistory");
              setShowMobileAside(false);
            }}
            className={`${
              activeSection === "OrphanDonationHistory"
                ? "p-[10px] bg-first_color/40 cursor-pointer flex items-center justify-center gap-5"
                : "p-[10px] hover:bg-first_color/20 duration-300 cursor-pointer flex items-center justify-center gap-5"
            }`}
          >
            <img src={kidIcon} alt="" />
            <p className=" lg:text-[14px] font-[500]">
              Orphan Donation History
            </p>
          </div>

          {/* Projects Donation History  **********/}
          <div
            onClick={() => {
              setActiveSection("ProjectsDonationHistory");
              setShowMobileAside(false);
            }}
            className={`${
              activeSection === "ProjectsDonationHistory"
                ? "p-[10px] bg-first_color/40 cursor-pointer flex items-center justify-center gap-5"
                : "p-[10px] hover:bg-first_color/20 duration-300 cursor-pointer flex items-center justify-center gap-5"
            }`}
          >
            <img src={coinsIcon} alt="" />
            <p className=" lg:text-[14px] font-[500]">
              Projects Donation History
            </p>
          </div>

          {/* General Donation History  **********/}
          <div
            onClick={() => {
              setActiveSection("GeneralDonationHistory");
              setShowMobileAside(false);
            }}
            className={`${
              activeSection === "GeneralDonationHistory"
                ? "p-[10px] bg-first_color/40 cursor-pointer flex items-center justify-center gap-5"
                : "p-[10px] hover:bg-first_color/20 duration-300 cursor-pointer flex items-center justify-center gap-5"
            }`}
          >
            <img src={donateIcon} alt="" />
            <p className=" lg:text-[14px] font-[500]">
              General Donation History
            </p>
          </div>

          {/* Orphan Sponsorship Reportt  **********/}
          <div
            onClick={() => {
              setActiveSection("OrphanSponsorshipReport");
              setShowMobileAside(false);
            }}
            className={`${
              activeSection === "OrphanSponsorshipReport"
                ? "p-[10px] bg-first_color/40 cursor-pointer flex items-center justify-center gap-5"
                : "p-[10px] hover:bg-first_color/20 duration-300 cursor-pointer flex items-center justify-center gap-5"
            }`}
          >
            <img src={sponserIcon} alt="" />
            <p className=" lg:text-[14px] font-[500]">
              Orphan Sponsorship Report
            </p>
          </div>

          {/* External Projects Reports  **********/}
          <div
            onClick={() => {
              setActiveSection("ExternalProjectsReports");
              setShowMobileAside(false);
            }}
            className={`${
              activeSection === "ExternalProjectsReports"
                ? "p-[10px] bg-first_color/40 cursor-pointer flex items-center justify-center gap-5"
                : "p-[10px] hover:bg-first_color/20 duration-300 cursor-pointer flex items-center justify-center gap-5"
            }`}
          >
            <img src={externalIcon} alt="" />
            <p className=" lg:text-[14px] font-[500]">
              External Projects Reports
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Aside;
